
class CapFilterRouteOnError {
  constructor(config) {
    this.config = config
  }

  // eslint-disable-next-line
  checkPermission(options = {}) {
    return Boolean(this.config)
  }
}

function key() {
  return 'filter_route_on_error'
}

function create(config) {
  return new CapFilterRouteOnError(config)
}

export default {
  key,
  create,
}
